// extracted by mini-css-extract-plugin
export var avatar = "avatar-module--avatar--gKNX7";